export default {"src":"/_next/static/media/404-graphic.7f2b2daf.svg","height":304,"width":470,"blurWidth":0,"blurHeight":0};